import axios from 'axios'
import store from '@/store'
import { appendPlatformType } from '@/utils/platformType'
import { attachApiRequestMeta, logApiError, logApiRequest, logApiResponse } from '@/utils/apiLogger'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + store.state.user.token

    const requestMethod = config.method && config.method.toLowerCase()
    if (requestMethod === 'get') {
      config.params = appendPlatformType(config.data ? config.data : config.params)
    } else if (requestMethod === 'post') {
      config.data = appendPlatformType(config.data)
    }

    // if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging') {
    //   config.headers['route-version'] = process.env.VUE_APP_ROUTE_VERSION
    // }

    const requestMeta = attachApiRequestMeta(config, config.data || config.params)
    logApiRequest(requestMeta)
    return config
  },
  error => {
    // do something with request error
    logApiError(error)
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    logApiResponse(response, res)
    return res
    // if the custom code is not 20000, it is judged as an error.
    // Vuex => 404
    // if (res.code !== 1 && res.code !== 10000) {
    //   switch (res.code) {
    //     case 5000:
    //       Dialog.alert({ message: res.message })
    //       break
    //     case 20001:
    //       store.dispatch('user/logout')
    //       // dsBridge.call('jsapi.clearSp', '')
    //       router.push('/login')
    //       break
    //     default:
    //       Toast.fail({
    //         message: res.message || 'Error',
    //         duration: 5 * 1000
    //       })
    //       break
    //   }
    //   return Promise.reject(res)
    // } else {
    //   return res
    // }
  },
  error => {
    logApiError(error)
    return Promise.reject(error)
  }
)

export default service
